var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"content-row",style:(_vm.style)},[_c('b-col',{staticClass:"content-box mx-auto",attrs:{"cols":"11","lg":"8"}},[_c('h3',[_vm._v(_vm._s(_vm.headline))]),_c('p',[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }